import { render, staticRenderFns } from "./table.pp36.vue?vue&type=template&id=1a8b6bfe&scoped=true"
import script from "./table.pp36.vue?vue&type=script&lang=js"
export * from "./table.pp36.vue?vue&type=script&lang=js"
import style0 from "./table.pp36.vue?vue&type=style&index=0&id=1a8b6bfe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8b6bfe",
  null
  
)

export default component.exports